import EmbeddedLayout from '../../layouts/EmbeddedLayout';
import AbortContent from '../shared/AbortContent';
import { type AbortVariant } from '../../types';

type Props = {
  errorCode?: number;
  errorMessage?: string;
  variant?: AbortVariant;
  onReject?: () => void;
  onRestart?: () => void;
  onBack?: () => void;
};

/**
 * Embedded abort page — renders a static error/abort screen without any
 * action buttons. In embedded mode the parent page controls what happens
 * next (it receives a `ronan:error` or `ronan:cancel` postMessage), so
 * we intentionally omit onReject, onRestart, and onBack.
 */
export default function EmbeddedAbortPage({ variant, errorCode }: Props) {
  return (
    <EmbeddedLayout>
      <AbortContent
        variant={variant}
        errorCode={errorCode}
        buttonDirection="col"
      />
    </EmbeddedLayout>
  );
}
